var React = require('react');

function IconAlignCenter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.571 3.929H.43A.429.429 0 0 0 0 4.357v.857a.429.429 0 0 0 .429.429H11.57A.429.429 0 0 0 12 5.214v-.857a.429.429 0 0 0-.429-.428Zm0 6.857H.43a.429.429 0 0 0-.429.428v.857a.429.429 0 0 0 .429.429H11.57a.429.429 0 0 0 .429-.429v-.857a.429.429 0 0 0-.429-.428ZM2.896 2.214h6.209a.324.324 0 0 0 .324-.324V.824A.324.324 0 0 0 9.105.5h-6.21a.324.324 0 0 0-.324.324V1.89a.324.324 0 0 0 .325.324Zm6.209 6.857a.324.324 0 0 0 .324-.324V7.681a.324.324 0 0 0-.324-.324h-6.21a.324.324 0 0 0-.324.324v1.066a.324.324 0 0 0 .325.324h6.209Z"}));
}

IconAlignCenter.defaultProps = {"fill":"#4D4540","viewBox":"0 0 12 13"};

module.exports = IconAlignCenter;

IconAlignCenter.default = IconAlignCenter;
